import ProjectsPage from './projects';

export default ProjectsPage;
